import { gql } from "apollo-boost";

export const GET_INFLUECERS = gql`
query Infulancers(
  $orderBy: OrderByInput
  $skip: Int
  $limit: Int
  $where: InfulancerWhereInput!
) {
  infulancers(orderBy: $orderBy, skip: $skip, limit: $limit, where: $where) {
    data {
      id
      first_name
      last_name
      gender
      phone
      email
      province_name
      district_name
      village_name
      category_document
      document_number
      bank_name
      account_name
      account_number
      status_register
      status_kyc
      infulancer_kyc
      status
      note
      isDeleted
      createdAt
      updatedAt
    }
    total
  }
}
`;

export const GET_SHOP_COMMISION_INFLUENCER = gql`
query ShopSettingCommissionInfulancers($where: ShopSettingCommissionInfulancerWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  shopSettingCommissionInfulancers(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      shop {
        id
        commision
        commissionAffiliate
        commissionService
        name
        phone
      }
      shop_name
      infulancer {
        first_name
        id
        last_name
        phone
        province_name
        district_name
        village_name
      }
      infulancer_name
      commission
      deduction
      type
      isDeleted
      createdAt
      updatedAt
      note
    }
  }
}
`;

export const DELETE_COMMISION_INFLUENCER = gql`
  mutation DeleteShopSettingCommissionInfulancer(
    $where: ShopSettingCommissionInfulancerWhereInputOne!
  ) {
    deleteShopSettingCommissionInfulancer(where: $where) {
      id
      shop_name
    }
  }
`;
